import React, { ReactNode } from "react";

import { HvTooltip, HvTypography } from "@hitachivantara/uikit-react-core";

export const wrapWithTooltip = (
  content: string | null | undefined,
  component: ReactNode,
  fixRef: boolean
): ReactNode => {
  if (content) {
    const child = fixRef ? <span>{component}</span> : component;

    return (
      <HvTooltip
        disableTouchListener
        title={<HvTypography>{content}</HvTypography>}
      >
        <span>{child}</span>
      </HvTooltip>
    );
  }

  return component;
};
